import copy from "copy-to-clipboard";
import toastr from "toastr";

const UseCopyToClipboard = (value, message) => {
    copy(value)
    const msg = message ? message : ':-) value has been copied to the clipboard'
    toastr['info'](`${msg}`, 'Information')
}

export default UseCopyToClipboard;